import React, { useRef, forwardRef, useImperativeHandle, useState } from 'react'
import { pick, keys, last, castArray } from 'lodash-es'
import { WebBasicForm } from '@ow/ditto'
import { Button } from '@ow/comps'
import { useFetchRemoteData, useTbViewStore } from '@vt/hooks'

// 判重的时候只能传末级
const leafValueTypes = ['area', 'standard']
const dealValue = (allFields, value) => {
  const obj = {}
  keys(value).forEach((v) => {
    const field = allFields.find((f) => f.slug === v)
    if (field && leafValueTypes.includes(field.type)) {
      obj[v] = last(castArray(value[v]))
    } else {
      obj[v] = value[v]
    }
  })

  return obj
}

const RepeatVerify = (
  { data, updateVerifyResult, updateIsReplace, updateDefaultValues },
  ref
) => {
  const verifyFormRef = useRef(null)
  const [repeatData, setRepeatData] = useState()
  const { judgeDataRepeat, collectorConfig, fields } = useTbViewStore((state) =>
    pick(state, ['judgeDataRepeat', 'collectorConfig', 'fields'])
  )

  const repeatVerifiyfilters =
    collectorConfig && collectorConfig.repeatVerifiyfilters
  const repeatResult = collectorConfig && collectorConfig.repeatResult

  const fetchRemoteData = useFetchRemoteData()
  const needRepeatVerifiySlugs =
    (repeatVerifiyfilters &&
      (repeatVerifiyfilters.queries || []).map((v) => v.slug)) ||
    []

  // 数据校验方法
  const verifyData = () => {
    // 获取校验数据
    if (verifyFormRef && verifyFormRef.current) {
      verifyFormRef.current.trigger().then((tr) => {
        console.log('data validate:', tr)
        if (tr) {
          const obj = verifyFormRef.current.getValues()
          const finalObj = dealValue(fields, obj)
          judgeDataRepeat(finalObj).then((_data) => {
            if (_data) {
              updateDefaultValues({})
              setRepeatData(_data)
            } else {
              updateDefaultValues(obj)
              updateVerifyResult(true)
              setRepeatData()
            }
          })
        }
        return null
      })
    }
  }

  if (ref) {
    useImperativeHandle(ref, () => ({
      verifyData,
      repeatData,
      getValues: () => {
        return verifyFormRef.current.getValues()
      },
    }))
  }

  return (
    <div className="w-full flex flex-col p-4 gap-2">
      <WebBasicForm
        fields={fields.filter((v) => needRepeatVerifiySlugs.includes(v.slug))} // 需判重的字段
        data={data}
        // onClickUpload={upload}
        config={collectorConfig}
        onFetchRemoteData={fetchRemoteData}
        ref={verifyFormRef}
      />

      {repeatData && (
        <div className="text-error-500" style={{ fontSize: '0.75rem' }}>
          {repeatResult === 'forbid' ? (
            <p>存在重复数据,请修改</p>
          ) : (
            <div className="flex gap-2 items-center">
              {repeatResult === 'allow' && <p>存在重复数据，是否继续添加？</p>}
              {repeatResult === 'replace' && <p>存在重复数据，是否替换？</p>}
              <Button
                type="primary"
                size="sm"
                onClick={() => {
                  // 添加
                  if (repeatResult === 'allow') {
                    updateVerifyResult(true)
                  }
                  // 数据替换
                  if (repeatResult === 'replace') {
                    updateIsReplace(true)
                    updateVerifyResult(true)
                  }
                }}
              >
                确定
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default forwardRef(RepeatVerify)
